import React from "react";
import { PlanrButton, Stack } from "modules/common/components/ui";
import { useInstall } from "../../../../mobile/services/install";
import { browserEnv, isPhone } from "../../../../mobile/services/version-core";
import { Banner } from "../banner/Banner";
import styles from "./InstallOffer.module.scss";

/**
 * Предложение установить Rost как приложение на компьютере — карточка общей стопки в правом
 * верхнем углу (R13, FR-020, FR-022, US5-1, T059). Показывается вошедшему пользователю на
 * компьютере, пока приложение не установлено, браузер позволяет установку и «Позже» не нажато
 * в последние 14 дней (крестик в углу — то же «Позже»). На телефоне полная версия предложения не показывает: там установка —
 * в мобильной версии.
 */
export const InstallOffer = () => {
    const { offerVisible, platform, prompt, snooze } = useInstall();
    const open = offerVisible && platform === "desktop" && !isPhone(browserEnv());

    return (
        <Banner open={open} label="Установка приложения" order={20} onClose={snooze}>
            <div className={styles.text}>Установите Rost как приложение</div>
            <Stack gap="s" justify="flex-end">
                <PlanrButton type="graybtn" size="small" onClick={snooze}>
                    Позже
                </PlanrButton>
                <PlanrButton type="primary" size="small" onClick={() => void prompt()}>
                    Установить
                </PlanrButton>
            </Stack>
        </Banner>
    );
};
